import { C, Input } from "@coremonit/design-system";
import type { ReactNode } from "react";

export function Field({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
  return (
    <div>
      <label style={{ display: "block", color: C.textSub, fontSize: 11, fontWeight: 600, marginBottom: 6 }}>{label}</label>
      {children}
      {hint && <div style={{ color: C.textMuted, fontSize: 10, marginTop: 4 }}>{hint}</div>}
    </div>
  );
}

export function OptionGrid<T extends string>({
  value, onChange, options, cols = 3,
}: {
  value: T | T[];
  onChange: (v: T) => void;
  options: Array<{ value: T; label: string; description?: string; icon?: ReactNode; badge?: string }>;
  cols?: number;
}) {
  const isMulti = Array.isArray(value);
  const isSelected = (v: T) => isMulti ? (value as T[]).includes(v) : value === v;
  return (
    <div style={{ display: "grid", gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 10 }}>
      {options.map((o) => {
        const sel = isSelected(o.value);
        return (
          <button
            key={o.value}
            onClick={() => onChange(o.value)}
            style={{
              textAlign: "left",
              padding: 14,
              background: sel ? C.blueDim : C.surfaceHigh,
              border: `1px solid ${sel ? C.borderBright : C.border}`,
              borderRadius: 14,
              cursor: "pointer",
              transition: "background 0.15s, border-color 0.15s",
              boxShadow: sel ? `0 0 20px rgba(45,127,249,0.15)` : "none",
              color: sel ? C.text : C.textSub,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 6, marginBottom: 6 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                {o.icon && <span style={{ color: sel ? C.blue : C.textMuted }}>{o.icon}</span>}
                <div style={{ color: sel ? C.text : C.text, fontSize: 12, fontWeight: 700 }}>{o.label}</div>
              </div>
              {o.badge && (
                <span style={{ fontSize: 9, fontWeight: 700, padding: "1px 6px", borderRadius: 6, background: C.blueDim, color: C.blue, border: `1px solid ${C.borderBright}` }}>{o.badge}</span>
              )}
            </div>
            {o.description && <div style={{ color: C.textMuted, fontSize: 11, lineHeight: 1.5 }}>{o.description}</div>}
          </button>
        );
      })}
    </div>
  );
}

export function StepHeader({ title, description }: { title: string; description: string }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ color: C.text, fontSize: 16, fontWeight: 700, marginBottom: 6 }}>{title}</div>
      <div style={{ color: C.textMuted, fontSize: 12, lineHeight: 1.6 }}>{description}</div>
    </div>
  );
}
